/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: audit.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateAuditFeedbackRequest,
  CreateAuditFeedbackResponse,
  CreateCaseAuditFeedbackRequest,
  CreateCaseAuditFeedbackResponse,
  GetAuditRequest,
  GetAuditResponse,
  GetCaseAuditRequest,
  GetCaseAuditResponse,
  ListAuditFeedbackRequest,
  ListAuditFeedbackResponse,
  ListAuditsRequest,
  ListAuditsResponse,
  ListCaseAuditFeedbackRequest,
  ListCaseAuditFeedbackResponse,
  ListCaseAuditsRequest,
  ListCaseAuditsResponse,
  UpdateAuditRequest,
  UpdateAuditResponse,
  UpdateCaseAuditRequest,
  UpdateCaseAuditResponse,
} from '../types/audit';

export const createAuditService = (transport: Transport) => ({
  async listAudits(
    request: ListAuditsRequest,
    options: RequestOptions = {},
  ): Promise<ListAuditsResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.AuditService.ListAudits, { organization_id, program_id });
    return transport.get<ListAuditsResponse>(url, { params, ...options });
  },

  async getAudit(
    request: GetAuditRequest,
    options: RequestOptions = {},
  ): Promise<GetAuditResponse> {
    const { organization_id, program_id, audit_id } = request;
    const url = getApiPath(API_METHODS.AuditService.GetAudit, {
      organization_id,
      program_id,
      audit_id,
    });
    return transport.get<GetAuditResponse>(url, options);
  },

  async updateAudit(
    request: UpdateAuditRequest,
    options: RequestOptions = {},
  ): Promise<UpdateAuditResponse> {
    const { organization_id, program_id, audit_id, ...body } = request;
    const url = getApiPath(API_METHODS.AuditService.UpdateAudit, {
      organization_id,
      program_id,
      audit_id,
    });
    return transport.post<UpdateAuditResponse>(url, body, options);
  },

  async createAuditFeedback(
    request: CreateAuditFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<CreateAuditFeedbackResponse> {
    const { organization_id, program_id, audit_id, ...body } = request;
    const url = getApiPath(API_METHODS.AuditService.CreateAuditFeedback, {
      organization_id,
      program_id,
      audit_id,
    });
    return transport.post<CreateAuditFeedbackResponse>(url, body, options);
  },

  async listAuditFeedback(
    request: ListAuditFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<ListAuditFeedbackResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.AuditService.ListAuditFeedback, {
      organization_id,
      program_id,
    });
    return transport.get<ListAuditFeedbackResponse>(url, { params, ...options });
  },

  async listCaseAudits(
    request: ListCaseAuditsRequest,
    options: RequestOptions = {},
  ): Promise<ListCaseAuditsResponse> {
    const { organization_id, program_id, case_id, ...params } = request;
    const url = getApiPath(API_METHODS.AuditService.ListCaseAudits, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.get<ListCaseAuditsResponse>(url, { params, ...options });
  },

  async getCaseAudit(
    request: GetCaseAuditRequest,
    options: RequestOptions = {},
  ): Promise<GetCaseAuditResponse> {
    const { organization_id, program_id, case_id, audit_id } = request;
    const url = getApiPath(API_METHODS.AuditService.GetCaseAudit, {
      organization_id,
      program_id,
      case_id,
      audit_id,
    });
    return transport.get<GetCaseAuditResponse>(url, options);
  },

  async updateCaseAudit(
    request: UpdateCaseAuditRequest,
    options: RequestOptions = {},
  ): Promise<UpdateCaseAuditResponse> {
    const { organization_id, program_id, audit_id, case_id, ...body } = request;
    const url = getApiPath(API_METHODS.AuditService.UpdateCaseAudit, {
      organization_id,
      program_id,
      audit_id,
      case_id,
    });
    return transport.post<UpdateCaseAuditResponse>(url, body, options);
  },

  async createCaseAuditFeedback(
    request: CreateCaseAuditFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<CreateCaseAuditFeedbackResponse> {
    const { organization_id, program_id, audit_id, case_id, ...body } = request;
    const url = getApiPath(API_METHODS.AuditService.CreateCaseAuditFeedback, {
      organization_id,
      program_id,
      audit_id,
      case_id,
    });
    return transport.post<CreateCaseAuditFeedbackResponse>(url, body, options);
  },

  async listCaseAuditFeedback(
    request: ListCaseAuditFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<ListCaseAuditFeedbackResponse> {
    const { organization_id, program_id, case_id, ...params } = request;
    const url = getApiPath(API_METHODS.AuditService.ListCaseAuditFeedback, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.get<ListCaseAuditFeedbackResponse>(url, { params, ...options });
  },
});

export type AuditService = ReturnType<typeof createAuditService>;
